import React from 'react';
import { Layout, Button } from 'antd';
import { Link, useNavigate } from 'react-router-dom';
import { BankOutlined, DashboardOutlined, LogoutOutlined } from '@ant-design/icons';
import { useDispatch, useSelector } from 'react-redux';
import './index.css';
import { SEARCH_STATE_KEY, SEARCH_LOB_KEY, SEARCH_TYPE_KEY } from './../../constants/searchConstants';
import { canManageData, homePathForRole, isAdmin } from '../../utils/roles';
import { signOutNow } from '../../utils/session';

const { Header } = Layout;

const AppHeader = () => {
  const { currentUser } = useSelector((state) => state.user);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleMenuClick = (key) => {
      navigate(key);
  };

  const handleLogout = () => {
    signOutNow(dispatch, navigate);
  };

  const clearSearch = () => {
    localStorage.removeItem(SEARCH_STATE_KEY);
    localStorage.removeItem(SEARCH_LOB_KEY);
    localStorage.removeItem(SEARCH_TYPE_KEY);
  }

  return (
    <Header className="app-header">
      <div className="header-content">
        <Link to="/" className="logo" onClick={() => clearSearch()}>
          <BankOutlined className="logo-icon" />
          <span className="logo-text">Market Finder</span>
        </Link>
        <div className="header-right">
          {canManageData(currentUser) && (
            <Button
              type="text"
              icon={<DashboardOutlined />}
              onClick={() => handleMenuClick(homePathForRole(currentUser?.role))}
              className="nav-button"
            >
              {isAdmin(currentUser) ? 'Dashboard' : 'Manage Data'}
            </Button>
          )}
           {/* <Link to="/compare">
            <Button type="link">Compare</Button>
          </Link> */}
          {/* <Link to="/about">
            <Button type="link">About</Button>
          </Link> */}
          {/* <Link to="/contact">
            <Button type="primary">Contact</Button>
          </Link> */}
          {currentUser && (
            <Button type="link" icon={<LogoutOutlined />} onClick={handleLogout}>
              Sign Out
            </Button>
          )}
        </div>
      </div>
    </Header>
  );
};

export default AppHeader;
